import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './FormField.styles';
import Checkbox from '../../inputs/checkbox/Checkbox';
import FileInput from '../../inputs/fileinput/FileInput';
import Input from '../../inputs/input/Input';
import Select from '../../inputs/select/Select';
import SelectGrid from '../../inputs/selectgrid/SelectGrid';
import RadioButton from '../../inputs/radiobutton/RadioButton';
import Multiselect from '../../inputs/multiselect/Multiselect';

export const LabelParent = props => (
  <label className={css(styles.base, props.styles)}>{props.children}</label>
);
export const DivParent = props => (
  <div className={css(styles.radioInput, props.styles)}>{props.children}</div>
);

const FormField = props => {
  let {
    label,
    text,
    styles: customStyles,
    type,
    placeholder,
    input,
    readOnly,
    options,
    maxLength,
    fullWidth,
    meta: { touched, error },
    dropzoneOptions
  } = props;
  let component;
  let showError = true;
  let ParentComponent = LabelParent;
  switch (type) {
    case 'checkbox':
      return (
        <label className={css(styles.baseCheckbox, customStyles)}>
          <Checkbox type={type} {...input} readOnly={readOnly} />
          <span className={css(styles.labelCheckbox)}>{label}</span>
        </label>
      );
    case 'radio': {
      component = (
        <RadioButton
          type="radio"
          readOnly={readOnly}
          styles={[!fullWidth && styles.halfWidth, styles.radio]}
          label={text}
          {...input}
        />
      );
      ParentComponent = DivParent;
      break;
    }
    case 'custom-radio':
      const { value, checked, ...rest } = input;
      const radioButtons = options.map((item, i) => {
        return (
          <RadioButton
            key={i}
            type="radio"
            label={item.label}
            value={item.value}
            checked={value === item.value}
            readOnly={readOnly}
            styles={[!fullWidth && styles.halfWidth]}
            {...rest}
          />
        );
      });
      ParentComponent = DivParent;
      component = <div className={css(styles.radioGroup)}>{radioButtons}</div>;
      break;
    case 'file':
      component = (
        <FileInput
          {...input}
          readOnly={readOnly}
          dropzoneOptions={dropzoneOptions}
          error={touched && error}
        />
      );
      showError = false;
      break;
    case 'select':
      component = (
        <Select
          {...input}
          readOnly={readOnly}
          options={options}
          placeholder={placeholder}
        />
      );
      ParentComponent = DivParent;
      break;
    case 'selectfilter':
      component = (
        <Select
          {...input}
          filter={true} 
          filterPlaceholder='Search' 
          filterBy='label,value'
          readOnly={readOnly}
          options={options}
          placeholder={placeholder}
        />
      );
      ParentComponent = DivParent;
      break;
    case 'multiselect':
      component = (
        <Multiselect
          {...input}
          readOnly={readOnly}
          options={options}
          placeholder={placeholder}
        />
      );
      ParentComponent = DivParent;
      break;
    case 'select-grid':
      component = (
        <SelectGrid {...input} readOnly={readOnly} options={options} />
      );
      ParentComponent = DivParent;
      break;
    case 'value':
      component = (
        <div
          className={css(styles.base, props.styles)}
          type={type}
          >{input.value}</div>
      );
      break;
    case 'text':
    default:
      component = (
        <Input
          type={type}
          disabled={readOnly}
          maxLength={maxLength}
          placeholder={placeholder}
          {...input}
        />
      );
      break;
  }
  return (
    <ParentComponent styles={[styles.parent, customStyles]}>
      {label && <span className={css(styles.label)}>{label}</span>}
      {component}
      {showError &&
        touched &&
        (error && <span className={css(styles.error)}>{error}</span>)}
    </ParentComponent>
  );
};

export default FormField;



// WEBPACK FOOTER //
// ./src/components/forms/formfield/FormField.js